import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_payment_request_stmt_hdr_ocr_RowClass, bl_b2b_payment_request_stmt_line_ocr_RowClass} from '../../../dbschema';

export class PaymentStatementOcrContainerModel extends BaseContainerModel {
    bl_b2b_payment_request_stmt_hdr_ocr: bl_b2b_payment_request_stmt_hdr_ocr_RowClass = new bl_b2b_payment_request_stmt_hdr_ocr_RowClass();
    bl_b2b_payment_request_stmt_line_ocrs: bl_b2b_payment_request_stmt_line_ocr_RowClass[] = []
}